import { render, staticRenderFns } from "./BetDialog.vue?vue&type=template&id=73bd15ae&scoped=true&"
import script from "./BetDialog.vue?vue&type=script&lang=js&"
export * from "./BetDialog.vue?vue&type=script&lang=js&"
import style0 from "./BetDialog.vue?vue&type=style&index=0&id=73bd15ae&scoped=true&lang=scss&"
import style1 from "./BetDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bd15ae",
  null
  
)

export default component.exports